import * as jstBroadcast from "../../native-modules/tare/jstBroadcast";
import { resetJobInteractionsForLogout } from "./jobInteractionsState";

/** Subscribe one RN provider root to logout cleanup and return an immediate teardown function. */
export function subscribeToJobInteractionsLogout(): () => void {
  let active = true;
  let subscription: jstBroadcast.JstBroadcastSubscription | null = null;

  void jstBroadcast
    .subscribe("UserDidLogout", resetJobInteractionsForLogout)
    .then((nextSubscription) => {
      if (!active) {
        void nextSubscription?.remove();
        return;
      }
      subscription = nextSubscription;
    });

  return () => {
    active = false;
    void subscription?.remove();
  };
}
